import React from 'react';

const DoneStatusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="13"
    fill="none"
    viewBox="0 0 18 13"
    className="done-status-icon"
  >
    <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 1L6 12 1 7" />
  </svg>
);

export default DoneStatusIcon;
